interface Image {
    image: string;
    _id: string;
    createdAt: string;
    updatedAt: string;
    imageUrl: string;
    id: string;
}

interface PropertyValue {
    id: string;
    title: string;
    value: string;
    imageUrl: string;
}

interface Property {
    id: string;
    title: string;
    type: string;
    values: PropertyValue[];
    createdAt: string;
    updatedAt: string;
}

interface SKUImage {
    image: string;
    _id: string;
    createdAt: string;
    updatedAt: string;
    imageUrl: string;
    id: string;
}

interface SKUValue {
    property: {
        title: string;
        id: string;
    };
    value: {
        title: string;
        id: string;
    };
}

interface SKU {
    quantity: number;
    SKU: string;
    price: number;
    images: SKUImage[];
    values: SKUValue[];
    createdAt: string;
    updatedAt: string;
}

export interface Product {
    _id?: string;
    title?: string;
    description?: string;
    slug?: string;
    price?: number;
    priceAfterDiscount?: number;
    discount?: number;
    discountType?: string;
    status?: string;
    privatePrice?: boolean;
    images?: Image[];
    properties?: Property[];
    skus?: SKU[];
    rate?: number;
    rateCount?: number;
    app?: string;
    deleted?: boolean;
    createdAt?: string;
}